import {
  Directive,
  ElementRef,
  HostListener,
  inject,
  input,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { NAME_PATTERN } from '@utilities/constants/reg-exp-patterns';

@Directive({
  selector: '[onlyName]',
})
export class OnlyNameDirective {
  onlyNameEnable = input(true);

  private _el = inject(ElementRef<HTMLInputElement>);
  private _control = inject(NgControl);

  @HostListener('input', ['$event'])
  onInputChange(event: { stopPropagation: () => void }) {
    if (!this.onlyNameEnable()) return;

    const initialValue = this._el.nativeElement.value;
    const cleaned = this._sanitize(initialValue, false);

    if (initialValue !== cleaned) {
      this._el.nativeElement.value = cleaned;
      this._control.control?.setValue(cleaned, { emitEvent: false });
      event.stopPropagation();
    }
  }

  @HostListener('blur')
  onBlur() {
    if (!this.onlyNameEnable()) return;

    const initialValue = this._el.nativeElement.value;
    const cleaned = this._sanitize(initialValue, true);

    if (initialValue !== cleaned) {
      this._el.nativeElement.value = cleaned;
      this._control.control?.setValue(cleaned, { emitEvent: false });
    }
  }

  private _sanitize(value: string, trimEnd: boolean): string {
    let cleaned = value;

    const allowedCharClass = this._extractFirstCharacterClass(NAME_PATTERN);

    if (allowedCharClass) {
      const removeDisallowedChars = new RegExp(`[^${allowedCharClass} ]+`, 'g');
      cleaned = cleaned.replace(removeDisallowedChars, '');
    }

    cleaned = cleaned.replace(/\s+/g, ' ');
    cleaned = cleaned.replace(/^\s+/g, '');

    if (trimEnd) {
      cleaned = cleaned.replace(/\s+$/g, '');
    }

    return cleaned;
  }

  private _extractFirstCharacterClass(pattern: string): string | null {
    const match = pattern.match(/\[([^\]]+)\]/);
    return match?.[1] ?? null;
  }
}
